module.exports = __webpack_public_path__ + "img/img_zanwu.eda86c55.png";